import Application from '@/shared/application.js'
import debounce from 'lodash.debounce'
import jump from 'jump.js'

new Application({
    data () {
        return {
            'paymentmethod': null,
            'price': 0,
            'discount': {
              mode: 'absolute',
              value: 0,
            },
            'discountDisplay': '',
            'paymentconfig': [],
            'modifiers': [],
            'modifierID': 0,
            'modifier': {},
        }
    },

    computed: {
        method() {
          return this.paymentconfig.find((method) => {
              return method.value === this.paymentmethod
          })
        },

        totalPrice() {
            let fee = (this.method ? this.method.fee : 0)

            let price = this.price
            price += this.modifierPriceAdjustment

            if (this.discount.value > 0) {
              switch (this.discount.mode) {
                case 'absolute':
                  price -= this.discount.value
                  break

                case 'percentage':
                  price -= ((this.discount.value / 100) * price)
                  break
              }
            }

            price += fee

            return Math.max(price, 0)
        },

        modifierPriceAdjustment() {
          if (typeof this.modifier.price === 'undefined') {
            return 0
          }

          return this.modifier.price
        },

        isPaymentRequired() {
          return this.totalPrice > 0
        },

        showModifiers() {
          return this.modifiers.length > 1
        },
    },

    methods: {
        init() {
            this.setData()
            if (_state.notifications.length) {
              this.scrollToForm()
            }
        },

        setData() {
            this.price = _state.price
            this.paymentconfig = _state.paymentconfig
            this.paymentmethod = _state.paymentmethod

            this.modifiers = this.processModifiers(_state.modifiers)
            this.modifierID = this.modifiers.length ? this.modifiers[0].id : 0
        },

        scrollToForm() {
          setTimeout(() => {
            jump('.register')
          }, 600)
        },

        checkDiscountCoupon: debounce(function(event) {
          let target = event.target
          this.updateDiscountCoupon(target)
        }, 500),

        updateDiscountCoupon(target) {
          let uri = target.getAttribute('data-uri')
          let value = target.value

          if (value.length < 3) {
            this.discount = {
              mode: 'absolute',
              value: 0,
            }
            this.discountDisplay = ''
            return
          }

          this.$http.post(uri, {
            event: _state.eventSlug,
            code: value,
          })
          .then(response => {
            const data = response.data

            this.discount = data.discount
            this.discountDisplay = data.discountDisplay
          })
          .catch(error => {
            // invalid request / code / combination
            this.discount = 0

            if (error.response) {
              const response = error.response
              let status = response.status || 422
              if (status === 404) {
                this.discountDisplay = 'code niet bekend'
                return
              }

              if (status === 422) {
                this.discountDisplay = 'korting kan niet worden toegepast'
                return
              }
            }

            this.discountDisplay = ''
          })
        },

        processModifiers(modifiers) {
          return modifiers.map(mod => {
            if (mod.price && mod.price != 0) {
              mod.title += ` (${mod.priceDisplay})`
            }

            return mod
          })
        },

        updateModifier(event) {
          this.modifier = this.modifiers.find(mod => {
            return mod.id == this.modifierID
          })
        }
    },

    mounted() {
        this.init()

        this.$nextTick(() => {
          this.updateDiscountCoupon(this.$refs.discountcode)
        })
    }
})



// WEBPACK FOOTER //
// ./resources/assets/front/js/modules/events.view.js